<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
  const SLOTS = $$props.$$slots || {};

  export let type = 'submit';
  export let shape;
  export let disabled = false;
  export let text;
  export let loading = false;
  export let loadingText = text;
  export let colorScheme = 'purple'; // || 'white'
  export let shadow = true;
  export let disableHoverEffect = false; // used for mobile in some cases
  export let size = 'medium';
</script>

<style style="text/scss" lang="scss">
  // NOTE: the design-system/buttons.scss file holds styles for buttons,
  // and only applies them to buttons with the mixin `bn-button`. This is best
  // used with the Button.svelte component, but could technically be used just
  // with the CSS classes.
  @import '../vendor/design-system.scss';

  .bn-button {
    @include bn-button;
  }
</style>

<button
  style={$$props.style || ''}
  class={`bn-button ${$$props.class}`}
  class:btn-purple={colorScheme === 'purple'}
  class:btn-white={colorScheme === 'white'}
  class:btn-black={colorScheme === 'black'}
  class:btn-red={colorScheme === 'red'}
  class:btn-gray={colorScheme === 'gray'}
  class:box-shadow={shadow}
  class:btn-small={size == 'small'}
  class:btn-small-plus={size == 'small-plus'}
  class:btn-medium={size == 'medium'}
  class:btn-large={size == 'large'}
  class:btn-full={size == 'full'}
  class:btn-shape-pill={shape == 'pill'}
  class:hover-disabled={disableHoverEffect}
  disabled={loading || disabled}
  type={type}
  on:click|preventDefault|stopPropagation={() => {
    if (disabled == false) {
      dispatch('click');
    }
  }}>
  <slot />

  {#if loading}
    <i class="fa fa-spinner fa-spin {$$props.spinnerClass}" />
  {/if}
  {#if SLOTS.content}
    <slot name="content" />
  {:else}
    <span class={$$props.contentClass}>
      {#if loading}
        {@html loadingText}
      {:else if text}
        {@html text}
      {/if}
    </span>
  {/if}
</button>
